import React from "react";
import { NavLink } from "react-router-dom";

const InternalDashboard = () => {
  return (
    <div>
      <div className="container fw-bold p-4">
        <h4>Internal Dashboard</h4>
        <div className="row text-center p-3 gx-5">
          <div className="col ">
            <NavLink
              to="/internaluser/internalevents"
              className="p-3 border shadow-sm banner text-white card rounded-3 text-decoration-none"
            >
              <h5>200</h5> Total Events
            </NavLink>
          </div>
          <div className="col ">
            <NavLink
              to="/internaluser/internalblogs"
              className="p-3 border shadow-sm  banner text-white card rounded-3  text-decoration-none"
            >
              <h5>200</h5> Total Blogs
            </NavLink>
          </div>
          <div className="col ">
            <NavLink
              to="/internaluser/internaltalks"
              className="p-3 border shadow-sm  banner text-white card rounded-3 text-decoration-none"
            >
              <h5>200</h5> Upcoming Talks
            </NavLink>
          </div>
          <div className="col ">
            <NavLink
              to="/internaluser/internalpodcast"
              className="p-3 border shadow-sm  banner text-white card rounded-3 text-decoration-none"
            >
              <h5>200</h5> Total Podcasts
            </NavLink>
          </div>
          <div className="col ">
            <NavLink
              to="/internaluser/internalnews"
              className="p-3 border shadow-sm  banner text-white card rounded-3 text-decoration-none"
            >
              <h5>200</h5> Total News
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalDashboard;
